import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField, DropDownMenu, MenuItem } from 'material-ui';

import Btn from '../../../components/Btn';
import '../../../grid.css';

class SolarInputs extends Component {
    toggleSystemInput() {
        const { setSolarInputsToggle, solarInputsToggle } = this.props;
        setSolarInputsToggle(!solarInputsToggle);
    }

    handleSystemSizeChange(value) {
        const { setSolarSystemSize } = this.props;
        setSolarSystemSize(Number(value));
    }

    handleProductionRatioChange(value) {
        const { setSolarProductionRatio } = this.props;
        setSolarProductionRatio(Number(value));
    }

    handleSystemPriceChange(value) {
        const { setSystemPrice } = this.props;
        setSystemPrice(Number(value));
    }

    handleSolarValueChange(value) {
        const { setSolarValue } = this.props;
        setSolarValue(Number(value));
    }

    handleAnnualDegChange(value) {
        const { setSolarAnnualDeg } = this.props;
        setSolarAnnualDeg(Number(value));
    }
    handleInstallTypeChange(value) {
        const { setInstallType } = this.props;
        setInstallType(value);
    }
    handleInstallTypeChange2(value) {
        const { setInstallType2 } = this.props;
        setInstallType2(value);
    }
    handleInverterChange(value) {
        const { setInverter } = this.props;
        setInverter(value);
    }
    handleSolarPanelChange(value) {
        const { setSolarPanel } = this.props;
        setSolarPanel(value);
    }
    HandleSystemNotesChange(value) {
        const { setSystemNotes } = this.props;
        setSystemNotes(value);
    }

    render() {
        const {
            annualDeg,
            isLocked,
            productionRatio,
            solarInputsToggle,
            solarValue,
            cashprice,
            systemSize,
            installType,
            installType2,
            solarPanel,
            inverter,
            systemNotes,
        } = this.props;

        return (
            <div className="inputsContainer">
                <Btn label="Solar" onClick={() => this.toggleSystemInput()} />
                {solarInputsToggle && (
                    <div>
                        <div className="col span-1-of-4">
                            <TextField
                                id="number"
                                type="number"
                                margin="dense"
                                defaultValue={systemSize}
                                hintText="500"
                                floatingLabelText="System Size (W)"
                                onChange={(e, value) => this.handleSystemSizeChange(value)}
                                disabled={isLocked}
                            />
                        </div>
                        <div className="col span-1-of-4">
                            <TextField
                                id="number"
                                type="number"
                                margin="dense"
                                defaultValue={productionRatio}
                                onChange={(e, value) => this.handleProductionRatioChange(value)}
                                hintText="1220"
                                floatingLabelText="kWh per kW"
                                disabled={isLocked}
                            />
                        </div>
                        <div className="col span-1-of-4">
                            <TextField
                                id="number"
                                type="number"
                                margin="dense"
                                defaultValue={cashprice}
                                onChange={(e, value) =>
                                    this.handleSystemPriceChange(value)
                                }
                                hintText="100,000"
                                floatingLabelText="Cash Price"
                                disabled={isLocked}
                            />
                        </div>
                        <div className="col span-1-of-4">
                            <TextField
                                id="number"
                                type="number"
                                margin="dense"
                                defaultValue={solarValue}
                                onChange={(e, value) => this.handleSolarValueChange(value)}
                                disabled={isLocked}
                                floatingLabelText="Solar Energy Value"
                            />
                        </div>
                        <div className="row">
                            <div className="col span-1-of-4">
                                <TextField
                                    id="number"
                                    type="number"
                                    margin="dense"
                                    defaultValue={annualDeg}
                                    onChange={(e, value) => this.handleAnnualDegChange(value)}
                                    floatingLabelText="Annual Degredation (%)"
                                    disabled={isLocked}
                                />
                            </div>
                            <div className="col span-1-of-4">
                                <p className="labelText">Solar Panel</p>
                                <DropDownMenu
                                    fullWidth
                                    floatingLabelText="Solar Panel"
                                    value={solarPanel}
                                    onChange={
                                        (e, index, value) => this.handleSolarPanelChange(value)}
                                    disabled={isLocked}
                                >
                                    <MenuItem value="ax320" primaryText="320W Axitec (BBB)" />
                                    <MenuItem value="cs325bbb" primaryText="325W Canadian Solar (BBB)" />
                                    <MenuItem value="pan330ac" primaryText="330W Panasonic  AC (BBB)" />
                                    <MenuItem value="han340" primaryText="340W Hanwha QCell (BBB)" />
                                    <MenuItem value="hyu395s" primaryText="395W Hyundai (Silver Frame)" />
                                    <MenuItem value="hyu400s" primaryText="400W Hyundai (Silver Frame)" />
                                    <MenuItem value="lg350W" primaryText="LG_350N1C-V5" />
                                    <MenuItem value="lg360W" primaryText="LG_360Q1K-V5 (BBB)" />
                                    <MenuItem value="rec365" primaryText="REC_Alpha_365 (BBB)" />
                                    <MenuItem value="lg400bif" primaryText="400W LG  Bifacial (Silver Frame)" />
                                </DropDownMenu>
                            </div>
                            <div className="col span-1-of-4">
                                <p className="labelText">Inverter</p>
                                <DropDownMenu
                                    fullWidth
                                    label="Inverter"
                                    value={inverter}
                                    onChange={
                                        (e, index, value) => this.handleInverterChange(value)}
                                    disabled={isLocked}
                                >
                                    <MenuItem value="enphase" primaryText="Enphase" />
                                    <MenuItem value="fronius" primaryText="Fronius" />
                                    <MenuItem value="generac" primaryText="Generac" />
                                    <MenuItem value="sma" primaryText="SMA" />
                                    <MenuItem value="solaredge" primaryText="Solar Edge" />
                                    <MenuItem value="solark" primaryText="SolArk" />
                                </DropDownMenu>
                            </div>
                            <div className="row">
                                <div className="col span-1-of-4">
                                    <p className="labelText">Install Type 1</p>
                                    <DropDownMenu
                                        fullWidth
                                        label="State"
                                        value={installType}
                                        onChange={
                                            (e, index, value) => this.handleInstallTypeChange(value)}
                                        disabled={isLocked}
                                    >
                                        <MenuItem value="pr" primaryText="Pitched Roof" />
                                        <MenuItem value="cm" primaryText="Corrugated Metal Roof" />
                                        <MenuItem value="gm" primaryText="Ground Mount" />
                                        <MenuItem value="fb" primaryText="Flat Ballasted" />
                                        <MenuItem value="rc" primaryText="Roof Canopy" />
                                        <MenuItem value="pc" primaryText="Parking Canopy" />
                                        <MenuItem value="o" primaryText="Other" />
                                    </DropDownMenu>
                                </div>
                                <div className="col span-1-of-4">
                                    <p className="labelText">Install Type 2</p>
                                    <DropDownMenu
                                        fullWidth
                                        label="State"
                                        value={installType2}
                                        onChange={
                                            (e, index, value) => this.handleInstallTypeChange2(value)}
                                        disabled={isLocked}
                                    >
                                        <MenuItem value="na" primaryText="N/A" />
                                        <MenuItem value="pr" primaryText="Pitched Roof" />
                                        <MenuItem value="cm" primaryText="Corrugated Metal Roof" />
                                        <MenuItem value="gm" primaryText="Ground Mount" />
                                        <MenuItem value="fb" primaryText="Flat Ballasted" />
                                        <MenuItem value="rc" primaryText="Roof Canopy" />
                                        <MenuItem value="pc" primaryText="Parking Canopy" />
                                        <MenuItem value="o" primaryText="Other" />
                                    </DropDownMenu>
                                </div>
                                <div className="col span-3-of-5">
                                    <TextField
                                        multiline
                                        fullWidth
                                        rowsMax="4"
                                        margin="dense"
                                        helperText="Miscelleneous System Notes For Customer"
                                        defaultValue={systemNotes}
                                        onChange={(e, value) => this.HandleSystemNotesChange(value)}
                                        disabled={isLocked}
                                        floatingLabelText="MISC System Notes"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

SolarInputs.propTypes = {
    annualDeg: PropTypes.number.isRequired,
    isLocked: PropTypes.bool.isRequired,
    productionRatio: PropTypes.number.isRequired,
    setSolarAnnualDeg: PropTypes.func.isRequired,
    setSolarProductionRatio: PropTypes.func.isRequired,
    setSolarValue: PropTypes.func.isRequired,
    setSolarSystemSize: PropTypes.func.isRequired,
    setSolarInputsToggle: PropTypes.func.isRequired,
    setSystemPrice: PropTypes.func.isRequired,
    solarInputsToggle: PropTypes.bool.isRequired,
    solarValue: PropTypes.number.isRequired,
    cashprice: PropTypes.number.isRequired,
    systemSize: PropTypes.number.isRequired,
    installType: PropTypes.string.isRequired,
    solarPanel: PropTypes.string.isRequired,
    inverter: PropTypes.string.isRequired,
    installType2: PropTypes.string.isRequired,
    systemNotes: PropTypes.string.isRequired,
    setInstallType: PropTypes.func.isRequired,
    setInstallType2: PropTypes.func.isRequired,
    setInverter: PropTypes.func.isRequired,
    setSolarPanel: PropTypes.func.isRequired,
    setSystemNotes: PropTypes.func.isRequired,
};

export default SolarInputs;



// WEBPACK FOOTER //
// ./src/containers/Inputs/SolarInputs/SolarInputs.js